
import React, { useState,useEffect } from 'react';
import { Form, Button, Container, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import axios from 'axios';
import { toast, Toaster } from 'react-hot-toast';
import { BASE_URL } from '../BaseURL';
import '../Assets/Css/loginpage.css';

const AdminLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleAdminLogin = async () => {
    if (!username || !password) {
      toast.error('Username and password are required');
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(`${BASE_URL}/enquiry/loginByPass`, {
        userName: username,
        password: password,
      });

      const { success, token, message } = response.data;

     if (success) {
  localStorage.setItem('agriToken', token);
  toast.success(message || 'Login Success!');

  // Give some time for localStorage to update and ProtectedRoute to re-render properly
  setTimeout(() => {
    navigate('/dashboard');
  }, 100); // 100ms delay
}else {
        toast.error(message || 'Login failed');
      }
    } catch (error) {
      const errMsg =
        error.response?.data?.message || 'Something went wrong. Try again.';
      toast.error(errMsg);
    }

    setLoading(false);
  };

//  useEffect(() => {
//   const token = localStorage.getItem('agriToken');
//   if (token) {
//     navigate('/dashboard');
//   }
// }, [localStorage.getItem('agriToken')]);

useEffect(() => {
  const token = localStorage.getItem('agriToken');
  if (token) {
    navigate('/dashboard');
  }
}, []);



  return (
    <Container fluid className="d-flex justify-content-center align-items-center login-container">
      <Toaster position="top-center" reverseOrder={false} />
      <Row className="w-100 d-flex justify-content-center align-items-center">
        <Col xs={12} md={6} lg={4} className="d-flex justify-content-center align-items-center">
          <div className="login-form-container">
            <h3 className="login-header">Admin Login</h3>
            <Form>
              <Form.Group className="mb-3" controlId="username">
                <Form.Label>Username</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter admin username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </Form.Group>

              <Form.Group className="mb-3 position-relative" controlId="password">
                <Form.Label>Password</Form.Label>
                <div className="position-relative">
                  <Form.Control
                    type={showPassword ? 'text' : 'password'}
                    placeholder="Enter admin password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <button
                    type="button"
                    className="password-toggle-btn"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
              </Form.Group>

              <Button
                type="button"
                className="w-100 login-button"
                onClick={handleAdminLogin}
                disabled={loading}
              >
                {loading ? 'Logging in...' : 'Login'}
              </Button>
            </Form>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default AdminLogin;

